<template>
  <div id="demo-basic-card">

    <div id="module-data">
        <div id="addPackageLoadingDiv" class="vs-con-loading__container">
            <vx-card :title="packageName" class="mb-base" style="min-height: 600px;">
                <form data-vv-scope="addPackageForm">
                    <div class="vx-row">
                        <div class="vx-col sm:w-full w-full mb-2">
                            Package name
                            <vs-input v-validate="'required'" name="name" ref="name" class="w-full" label="" v-model="package_data.name" />
                            <span class="text-danger text-sm" v-show="errors.has('addPackageForm.name')">{{ errors.first('addPackageForm.name') }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-2">
                        <div class="vx-col sm:w-full w-full mb-4">
                            <vs-input v-validate="'required|min:1|max_value:1000000'" name="price" ref="price" class="w-full" label="Cost" v-model="package_data.price" />
                            <span class="text-danger text-sm" v-show="errors.has('addPackageForm.price')">{{ errors.first('addPackageForm.price') }}</span>
                        </div>
                    </div>

                    <div class="vx-row mt-base">
                        <div class="vx-col w-full mb-2">
                            Description
                            <vs-textarea v-model="package_data.description" />
                        </div>
                    </div>

                    <div class="vx-row mt-2">
                        <div class="vx-col  w-full mb-4">
                            <div id="viewTestsLoadingDiv" class="vs-con-loading__container">
                                <div class="vx-col w-full mb-4">
                                    Tests
                                    <vs-table 
                                        max-items="20"
                                        @change-page="handleChangePage"
                                        @sort="handleSort"
                                        :data="testsData">

                                        <template slot="thead">
                                            <vs-th>Id</vs-th>
                                            <vs-th>Image</vs-th>
                                            <vs-th>Test name</vs-th>
                                            <vs-th>Max attempts</vs-th>
                                        </template>

                                        <template slot-scope="{data}">
                                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                                <vs-td :data="data[indextr].id">
                                                    <vs-checkbox :vs-value="data[indextr]" :value="data[indextr]" v-model="selected"></vs-checkbox>
                                                </vs-td>
                                                <vs-td :data="data[indextr].picture">
                                                    <img width="80" :src="data[indextr].picture" alt="content-img">
                                                </vs-td>
                                                <vs-td :data="data[indextr].name">
                                                    {{data[indextr].name}}
                                                </vs-td>
                                                <vs-td>
                                                    <vs-input v-validate="'numeric'" :name="'attempts_'+indextr" :ref="'attempts_'+indextr" class="w-full" label="" v-model="data[indextr].max_attempts" />
                                                    <span class="text-danger text-sm" v-show="errors.has('addPackageForm.attempts_'+indextr)">{{ errors.first('addPackageForm.attempts_'+indextr) }}</span>
                                                </vs-td>
                                            </vs-tr>
                                        </template>
                                    </vs-table>

                                    <div class="vx-row mt-base">
                                        <div class="vx-col w-full mb-2">
                                            <vs-pagination :total="totalPage" v-model="currentPage"></vs-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col w-full"  align="right">
                          <vs-button @click="validateCreatePackage()" class="mr-3 mb-2">Create package</vs-button>
                        </div>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import vSelect from 'vue-select'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default{
    data() {
        return {
            package_data: {
                name : null,
                price : null,
                special_price : null,
                description : null,
                price_type : 'free',
            },
            package_not_found: false,
            swiperOption: {
                pagination: {
                    el: '.swiper-pagination'
                }
            },
            modules_values : [],
            modules_options : [],
            otherModuleType_ : null,
            packageName : null,
            search : null,
            totalPage: 1,
            currentPage: 1,
            selected:[],
        }
    },
    components: {
        VuePerfectScrollbar,
        swiper,
        swiperSlide,
        vSelect,
        Treeselect,
    },
    computed: {
        priceType: {
            set: function(val) {
                this.package_data.price_type = val.toLowerCase();
            },
            get: function() {
                let type = this.package_data.price_type
                return type[0].toUpperCase() + type.slice(1);
            }
        },
        testsData() {
            return this.$store.state.questionManagement.tests
        },
    },
    methods: {
        handleSearch(searching) {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.search = searching
                this.searchTests()
            }, 2000);   
        },
        handleChangePage(page) {
            // this.searchUser()
        },
        handleSort(key, active) {
            if(key){
                this.key = key
                this.active = active
                this.searchTests()
            }
        },
        async searchTests() {
            var self = this
            this.$vs.loading({
                container: '#viewTestsLoadingDiv',
                scale: 0.6
            })

            let data = { 
                lang : this.test_data.lang, 
                page : this.currentPage,
            }

            await this.$store.dispatch("questionManagement/getAllQuestions", data)
                .then(res => { 
                    this.totalPage = res.data.last_page
                    this.$vs.loading.close('#viewQuestionsLoadingDiv > .con-vs-loading')
                })
                .catch(err => { 
                    this.$vs.loading.close('#viewQuestionsLoadingDiv > .con-vs-loading')
                })
          
        },
        redirectToAllPackages() {
            this.$router.push("/packages").catch(() => {})
        },
        validateCreatePackage() {
            this.$validator.validateAll('addPackageForm').then(result => {
                if (result){
                    if(this.selected.length) this.createPackage();
                    else{
                        this.$vs.notify({
                          time:4000,
                          title:'Error',
                          text: "Please select tests.",
                          color:'warning',
                          iconPack: 'feather',
                          icon:'icon-alert-circle'
                        });
                    }
                }
            })
        },
        createPackage() {
            var self = this
            var attempts = [];
            var theoryTest = [];

            this.$vs.loading({
                container: '#addPackageLoadingDiv',
                scale: 0.6
            })

            let packageData = this.package_data
            
            for (var i = 0; i < this.selected.length; i++) {
                theoryTest.push(this.selected[i].id)
                attempts.push({
                    test_id : this.selected[i].id,
                    max_attempts : this.selected[i].max_attempts,
                    min_attempts : this.selected[i].min_attempts,
                })
            }

            packageData.attempts = attempts;
            packageData.theory_test = theoryTest;


            this.$store.dispatch("questionManagement/createPackage", packageData)
            .then(res => { 
                this.$vs.loading.close('#addPackageLoadingDiv > .con-vs-loading')

                this.$vs.notify({
                  time:4000,
                  title:'Success',
                  text: 'Package Sussfully Created.',
                  color:'success',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'
                });

                this.$router.push("/packages").catch(() => {})
            })
            .catch(err => {
                this.$vs.loading.close('#addPackageLoadingDiv > .con-vs-loading')

                if(err.status && err.status == 422){
                    Object.keys(err.data).forEach(function(key) {
                        self.errors.add({
                            field: key,
                            msg: err.data[key][0],
                        });
                    });
                }
            })
        },
    },
    created() {
        if(!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }

        this.$store.dispatch("questionManagement/getAllTests")
    },

}
</script>

